import React, { useState, useEffect } from "react";
import {
    AutoSearchDropdown,
    InputBox,
    SelectDropDown,
    TextArea,
} from "../../../components/Custom";
import { H4FormLabel } from "../../../theme/Theme";
import {
    Box,
    Grid,
    Typography,
    CircularProgress,
    Button,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
    Select,
    MenuItem,
    TextField, Chip
} from "@mui/material";
import ThemeColor from "../../../theme/ThemeColor";
import DisplayError from "../../../validation/DisplayError";
import HeaderName from "../../../components/Custom/HeaderName";
import { useLocation, useNavigate } from "react-router";
import validate from "../../../validation/validation";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { ContentsList } from "../../utils/constant"
import { getOfficeList } from "../../../redux/Thunk/officeThunk"
import { getCustomerList } from "../../../redux/Thunk/customerThunk"
import { Country, State, City } from 'country-state-city';
import { createPackageDetails, createPickupDetails, deletePackageDetails, updatePickupDetails } from "../../../redux/Thunk/officePickupThunk"
import moment from "moment"
import { EditIcon } from "../../../components/Icons";

/** Legacy pickups stored total NoOfPcs on the header and per-line count in Pkg. */
const normalizePackageRows = (packageDetails = [], pickupNoOfPcs = '') => {
    const list = Array.isArray(packageDetails) ? packageDetails.filter(Boolean) : [];
    if (!list.length) return [];

    const headerPcs = pickupNoOfPcs !== undefined && pickupNoOfPcs !== null && String(pickupNoOfPcs).trim() !== ''
        ? String(pickupNoOfPcs).trim()
        : '';

    return list.map((row) => {
        const existing = row?.NoOfPcs !== undefined && row?.NoOfPcs !== null && String(row.NoOfPcs).trim() !== ''
            ? String(row.NoOfPcs).trim()
            : '';
        if (existing) return { ...row, NoOfPcs: existing };

        const fromPkg = row?.Pkg !== undefined && row?.Pkg !== null && String(row.Pkg).trim() !== ''
            ? String(row.Pkg).trim()
            : '';
        if (fromPkg) return { ...row, NoOfPcs: fromPkg };

        return { ...row };
    }).map((row, _index, all) => {
        if (row.NoOfPcs) return row;
        if (all.length === 1 && headerPcs) return { ...row, NoOfPcs: headerPcs };
        return row;
    });
};

const getRowNoOfPcs = (row) => {
    if (row?.NoOfPcs !== undefined && row?.NoOfPcs !== null && String(row.NoOfPcs).trim() !== '') {
        return row.NoOfPcs;
    }
    if (row?.Pkg !== undefined && row?.Pkg !== null && String(row.Pkg).trim() !== '') {
        return row.Pkg;
    }
    return '';
};

const NewPickup = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { state } = useLocation()
    const { officeList } = useSelector((state) => state.office)
    const { CustomerList } = useSelector((state) => state.customer)
    const [editPickupDetails, setEditPickupDetails] = useState(state?.editDetails ? state?.editDetails : {})
    const [error, setError] = useState([]);
    const todayDate = dayjs();   // todays date

    // Multiple ReceiverEmail
    const [ReceiverEmail, setReceiverEmail] = useState([]);
    const [inputValue, setInputValue] = useState('');

    // Multiple ReceiverEmail
    const [SenderEmail, setSenderEmail] = useState([]);
    const [inputValueSender, setInputValueSender] = useState('');
    const [loader, setLoader] = useState(false)
    const [displayErrorMsg, setDisplayErrorMsg] = useState(false)
    const [pickupDetails, setPickupDetails] = useState({
        OfficeId: '',
        Customer: '',
        GrossWeight: '',
        DataLogger: '',
        DataLoggerValue: '',
        Content: '',
        PackegeType: '',
        // PickupRegistered:'',
        // PickupRegisteredNumber:'',
        Remark: '',
        Consigner: '',
        Consignee: '',
        ReceiverName: '',
        PickupDateAndTime:'',
        ReceiverMobile: '',
        SenderName: '',
        SenderMobile: '',
        OriginState: "",
        DestinationState: "",
        Origin: '',
        Destination: ''
    })
    const [Destination, setDestination] = useState('')
    const [Origin, setOrigin] = useState('')
    const [PickupDateAndTime, setPickupDateAndTime] = useState(null)
    const [pickupDate, setPickupDate] = useState(null);
    const [pickupTime, setPickupTime] = useState(null);
    const [pickupAddress, setPickupAdress] = useState({
        Address: '',
        Pincode: ''
    })
    const [destinationAddress, setDestinationAdress] = useState({
        Address: '',
        Pincode: ''
    })
    const [form, setForm] = useState({
        BoxType: '',
        Pkg: '',
        Temperature: '',
        TemperatureTypeId: '',
        Volumetrix: '',
        breadth: '',
        height: '',
        length: '',
        Actualweight: "",
        NoOfPcs: '',
    });
    const [rows, setRows] = useState([]);
    const cities = City.getCitiesOfState('IN', 'MH'); // India, Maharashtra
    const cityOptions = cities.map(city => ({
        label: city.name,
        value: city.name,
    }));

    const stateOptions = State.getStatesOfCountry('IN').map((state) => ({
        value: state.isoCode,
        label: state.name,
    }));
    const [editIndex, setEditIndex] = useState(null);    //for editing package details

    useEffect(() => {
        dispatch(getOfficeList({ page: 1, limit: 10000, search: "", role: 'OfficeAdmin' }))
        dispatch(getCustomerList({ page: 1, limit: 10000, search: '' }))
        if (Object.keys(editPickupDetails).length > 0) {
            setPickupDetails({
                OfficeId: editPickupDetails?.OfficeId || '',
                Customer: editPickupDetails?.Customer || '',
                // ReceiverEmail: editPickupDetails?.ReceiverEmail || '',
                // SenderEmail: editPickupDetails?.SenderEmail || '',
                GrossWeight: editPickupDetails?.GrossWeight || '',
                DataLogger: editPickupDetails?.DataLogger || '',
                DataLoggerValue: editPickupDetails?.DataLoggerValue || '',
                Content: editPickupDetails?.Content || '',
                PackegeType: editPickupDetails?.PackegeType || '',
                // PickupRegistered: editPickupDetails?.PickupRegistered || '',
                // PickupRegisteredNumber: editPickupDetails?.PickupRegisteredNumber || '',
                Remark: editPickupDetails?.Remark || '',
                Consigner: editPickupDetails?.Consigner || '',
                PickupDateAndTime: editPickupDetails?.PickupDateAndTime || '',
                Consignee: editPickupDetails?.Consignee || '',
                SenderName: editPickupDetails?.SenderName || '',
                SenderMobile: editPickupDetails?.SenderMobile || '',
                ReceiverName: editPickupDetails?.ReceiverName || '',
                ReceiverMobile: editPickupDetails?.ReceiverMobile || '',
                Origin: editPickupDetails?.Origin || '',
                Destination: editPickupDetails?.Destination || "",
                OriginState: editPickupDetails?.OriginState || "",
                DestinationState: editPickupDetails?.DestinationState || "",
            })
            setRows(normalizePackageRows(editPickupDetails?.PackageDetails, editPickupDetails?.NoOfPcs));
            // setForm({
            //     BoxType: editPickupDetails?.PackageDetails[0]?.BoxType || '',
            //     Pkg: editPickupDetails?.PackageDetails[0]?.Pkg || '',
            //     Temperature: editPickupDetails?.PackageDetails[0]?.Temperature || '',
            //     TemperatureTypeId: editPickupDetails?.PackageDetails[0]?.TemperatureTypeId || '',
            //     Volumetrix: editPickupDetails?.PackageDetails[0]?.Volumetrix || '',
            //     breadth: editPickupDetails?.PackageDetails[0]?.breadth || '',
            //     height: editPickupDetails?.PackageDetails[0]?.height || '',
            //     length: editPickupDetails?.PackageDetails[0]?.length || '',
            // })

            setSenderEmail(editPickupDetails?.SenderEmail || [])
            setReceiverEmail(editPickupDetails?.ReceiverEmail || [])
            // Destination address split ==========================
            const parts = editPickupDetails?.DestinationAddress?.split(',')?.map(part => part.trim());
            const pincodeDestination = parts?.pop();        // "413512"        // "Pune"

            // Remaining parts form the main address
            const addressDestination = parts?.join(', ');
            setDestinationAdress({
                Pincode: pincodeDestination || '',
                Address: addressDestination || ''
            })
            // Pickup address split ==========================
            const partPickup = editPickupDetails?.PickupAddress?.split(',')?.map(part => part.trim());
            const pincodePickup = partPickup?.pop();       // "Pune"

            // Remaining parts form the main address
            const addressPickup = partPickup?.join(', ');
            setPickupAdress({
                Pincode: pincodePickup || '',
                Address: addressPickup || ''
            })
            setOrigin(editPickupDetails?.Origin || '')
            setDestination(editPickupDetails?.Destination || '')
            const momentObj = moment(editPickupDetails.PickupDateAndTime); // parse the ISO string
            const dayjsObj = dayjs(momentObj.toISOString());               // convert to dayjs
            setPickupDateAndTime(dayjsObj);
            if (editPickupDetails?.PickupDateAndTime) {
                const momentObj = moment(editPickupDetails.PickupDateAndTime);
                const dayjsObj = dayjs(momentObj.toISOString());

                setPickupDate(dayjsObj); // Only the date part
                setPickupTime(dayjsObj); // Only the time part
            }
        }
    }, [])

    const handleChangePickup = (e) => {
        setPickupDetails({ ...pickupDetails, [e.target.name]: e.target.value })
    }

    const handleDateChange = (date) => {
        if (date) {
            setPickupDateAndTime(date);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedForm = {
            ...form,
            [name]: value
        };

        // Parse values as float (handle empty or non-numeric gracefully)
        const length = parseFloat(updatedForm.length) || '';
        const breadth = parseFloat(updatedForm.breadth) || '';
        const height = parseFloat(updatedForm.height) || '';
        const pkg = parseInt(updatedForm.Pkg) || 0;

        // Calculate Volumetrix using the formula (L × B × H) / 5000
        const volumetrix = ((length * breadth * height) / 5000) * pkg;

        // Set the Volumetrix value with 2 decimal places
        updatedForm.Volumetrix = volumetrix ? volumetrix.toFixed(2) : '';
        setForm(updatedForm);

    };

    let validation_input1 = [
        { tagid: 'NoOfPcs', text: form?.NoOfPcs ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Enter Number of Pcs.', min: 1, max: 50 },
        // Package Details
        // {tagid:'BoxType', text:form?.BoxType ??'', regex_name: 'free_text', required: true, errmsg: 'Please Enter Box Type.', min:1, max: 50},
        // {tagid:'Temperature', text:form?.Temperature ??'', regex_name: 'any_number', required: true, errmsg: 'Please Enter Temperature.', allow_negative:false, allow_decimal: true},
        // {tagid:'TemperatureTypeId', text:form?.TemperatureTypeId ??'', regex_name: 'free_text', required: true, errmsg: 'Please Enter Type.', min:1, max: 50},
        // {tagid:'Actualweight', text:form?.Actualweight ??'', regex_name: 'free_text', required: true, errmsg: 'Please Enter Actual Weight.', min:1, max: 50},
        // {tagid:'Pkg', text:form?.Pkg ??'', regex_name: 'any_number', required: true, errmsg: 'Please Enter Pkg.', allow_negative:false, allow_decimal: true},

        // {tagid:'breadth', text: form?.breadth ??'', regex_name: 'any_number', required: true, errmsg: 'Please Enter Breadth.', allow_negative:false, allow_decimal: true},
        // {tagid:'height', text:form?.height ??'', regex_name: 'any_number', required: true, errmsg: 'Please Enter Height.', allow_negative:false, allow_decimal: true},
        // {tagid:'length', text:form?.length ??'', regex_name: 'any_number', required: true, errmsg: 'Please Enter Length.', allow_negative:false, allow_decimal: true},
    ]

    const validateEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email); // Simple email format validation
    };

    // Add package details in locally
    // const handleAddRow = () => {

    // const totalPcs = parseInt(pickupDetails?.NoOfPcs || 0);
    // const usedPcs = rows.reduce((sum, row) => sum + parseInt(row.Pkg || 0), 0);
    // const currentPkg = parseInt(form.Pkg || 0);
    // const availablePcs = totalPcs - usedPcs;


    //    if (availablePcs === 0) {
    //    setError([  { tagid: 'Pkg', errmsg: `All ${totalPcs} pcs are already added. You can't add more.` }]);
    //    return;
    //    }
    //    if (currentPkg > availablePcs) {
    //     const errmsg = usedPcs === 0   ? `Only ${totalPcs} pcs are allowed.`  : `Only ${availablePcs} pcs are left to add.`; // Later entries
    //      setError([{ tagid: 'Pkg', errmsg }]);
    //     return;
    //  }

    //     if (validate(validation_input1)?.length === 0) {
    //         if (editIndex !== null) {
    //             const updatedRows = [...rows];
    //             updatedRows[editIndex] = form;
    //             setRows(updatedRows);
    //             setEditIndex(null); // reset after editing
    //             setForm({
    //             BoxType:'', Pkg:'', Temperature:'', TemperatureTypeId:'', Volumetrix:'', breadth:'', height:'', length:''
    //         }); // Reset form
    //         } else {
    //             setRows([...rows, form]);
    //         }
    //         setError([]);
    //     } else {
    //         setError(validate(validation_input1));
    //     }
    // }
    const handleAddRow = () => {
        if (validate(validation_input1)?.length === 0) {
            if (editIndex !== null) {
                const updatedRows = [...rows];
                updatedRows[editIndex] = form;
                setRows(updatedRows);
                setEditIndex(null);
                setForm({
                    BoxType: '', Pkg: '', Temperature: '', TemperatureTypeId: '', Volumetrix: '', breadth: '', height: '', length: '', Actualweight: '', NoOfPcs: '',
                });
            } else {
                setRows([...rows, form]);
                setForm({
                    BoxType: '', Pkg: '', Temperature: '', TemperatureTypeId: '', Volumetrix: '', breadth: '', height: '', length: '', Actualweight: '', NoOfPcs: '',
                });
            }
            setError([]);
        } else {
            setError(validate(validation_input1));
        }
    }

    // delete package details
    const handleDeleteRow = (index, row) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
        // setForm(updatedRows)
    };

    const handleClickEditRow = (index, row) => {
        console.log(row, "row")
        setForm({
            BoxType: row?.BoxType || '',
            Pkg: row?.Pkg || '',
            Temperature: row?.Temperature || '',
            TemperatureTypeId: row?.TemperatureTypeId || '',
            Volumetrix: row?.Volumetrix || '',
            breadth: row?.breadth || '',
            height: row?.height || '',
            length: row?.length || '',
            Actualweight: row?.Actualweight || "",
            NoOfPcs: getRowNoOfPcs(row),
        })
        setEditIndex(index)
    }

    // Check validation for empty any field in destination and resister address
    const checkValidation = () => {
        const { Address, Pincode } = pickupAddress;
        if (!Address?.trim() || !Pincode?.trim() || !destinationAddress?.Address?.trim() || !destinationAddress?.Pincode?.trim()) {
            setDisplayErrorMsg(true);
            return true;
        } else {
            setDisplayErrorMsg(false);
            return false;
        }
    };

    // let check_first_digit = pickupDetails?.PickupRegisteredNumber ? pickupDetails?.PickupRegisteredNumber[0] : 0 
    let check_first_digitOne = pickupDetails?.ReceiverMobile ? pickupDetails?.ReceiverMobile[0] : 0
    let check_first_digitone = pickupDetails?.SenderMobile ? pickupDetails?.SenderMobile[0] : 0
    let validation_input = [
        { tagid: 'OfficeId', text: pickupDetails?.OfficeId ?? '', required: true, regex_name: 'free_text', errmsg: 'Please Select Office Name.', min: 1, max: 50 },
        { tagid: 'Customer', text: pickupDetails?.Customer ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Select Customer Name.', min: 1, max: 50 },
        { tagid: 'Origin', text: pickupDetails?.Origin ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Select Origin City.', min: 1, max: 50 },
        { tagid: 'OriginState', text: pickupDetails?.OriginState ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Select Origin State.', min: 1, max: 50 },
        { tagid: 'Destination', text: pickupDetails?.Destination ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Select Destination City.', min: 1, max: 50 },
        { tagid: 'DestinationState', text: pickupDetails?.DestinationState ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Select Destination State.', min: 1, max: 50 },
        { tagid: 'ReceiverEmail', text: ReceiverEmail, regex_name: 'free_text', required: true, errmsg: 'Please Enter Valid Email.', min: 1, max: 500 },
        { tagid: 'SenderEmail', text: SenderEmail, regex_name: 'free_text', required: true, errmsg: 'Please Enter Valid Email.', min: 1, max: 500 },
        // Number(check_first_digit) <= 5 ? {tagid:'Mobile', text:officeDetails?.Mobile, required:true, regex_name: 'exact_x_digits', errmsg:'Please Enter Valid Number.' } : {tagid:'Mobile', text:officeDetails?.Mobile, regex_name: 'exact_x_digits', required: true, errmsg:'Please Enter Valid Number', x_count:10 },
        { tagid: 'GrossWeight', text: pickupDetails?.GrossWeight ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Enter Gross Weight.', min: 1, max: 50 },
        pickupDetails?.DataLoggerValue === 'Yes' ? { tagid: 'DataLogger', text: pickupDetails?.DataLogger ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Enter Data Logger.', min: 1, max: 50 } : <></>,
        { tagid: 'DataLoggerValue', text: pickupDetails?.DataLoggerValue ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Enter Value.', min: 1, max: 50 },
        { tagid: 'Content', text: pickupDetails?.Content ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Enter Content.', min: 1, max: 50 },
        { tagid: 'PackegeType', text: pickupDetails?.PackegeType ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Enter Type.', min: 1, max: 50 },

        // {tagid:'pickupTime', text:pickupTime?.length === 0 ? null: pickupTime?.$d, regex_name: 'free_text', required: true, errmsg: 'Please Select Date And Time.', min:1, max: 5000},
        // Number(check_first_digit) <= 5 ? {tagid:'PickupRegisteredNumber', text:pickupDetails?.PickupRegisteredNumber, required:true, regex_name: 'exact_x_digits', errmsg:'Please Enter Valid Number.' } : {tagid:'PickupRegisteredNumber', text:pickupDetails?.PickupRegisteredNumber, regex_name: 'exact_x_digits', required: true, errmsg:'Please Enter Valid Number', x_count:10 },
        // {tagid:'PickupRegistered', text:pickupDetails?.PickupRegistered ??'', regex_name: 'text', required: true, errmsg: 'Please Enter Pickup Registered By.', allow_numbers: false, other_chars: ' ', min:3, max: 50},
        { tagid: 'Remark', text: pickupDetails?.Remark ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Enter Remark', min: 1, max: 150 },
        { tagid: 'Consigner', text: pickupDetails?.Consigner ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Select Consigner Name.', min: 1, max: 50 },
        { tagid: 'Consignee', text: pickupDetails?.Consignee ?? '', regex_name: 'free_text', required: true, errmsg: 'Please Select Consignee Name.', min: 1, max: 50 },
        { tagid: 'ReceiverName', text: pickupDetails?.ReceiverName ?? '', regex_name: 'text', required: true, errmsg: 'Please Enter Receiver Name.', allow_numbers: false, other_chars: ' ', min: 3, max: 50 },
        { tagid: 'SenderName', text: pickupDetails?.SenderName ?? '', regex_name: 'text', required: true, errmsg: 'Please Enter Sender Name.', allow_numbers: false, other_chars: ' ', min: 3, max: 50 },
        { tagid: 'PickupDate', text: pickupDate ?? '',regex_name: 'datetime', required: true, errmsg: 'Please select Pickup Date' },
        { tagid: 'PickupTime', text: pickupTime ?? '', regex_name: 'datetime', required: true, errmsg: 'Please select Pickup Time' },
         Number(check_first_digitOne) <= 5 ? { tagid: 'ReceiverMobile', text: pickupDetails?.ReceiverMobile, required: true, regex_name: 'exact_x_digits', errmsg: 'Please Enter Valid Number.' } : { tagid: 'ReceiverMobile', text: pickupDetails?.ReceiverMobile, regex_name: 'exact_x_digits', required: true, errmsg: 'Please Enter Valid Number', x_count: 10 },
        Number(check_first_digitone) <= 5 ? { tagid: 'SenderMobile', text: pickupDetails?.SenderMobile, required: true, regex_name: 'exact_x_digits', errmsg: 'Please Enter Valid Number.' } : { tagid: 'SenderMobile', text: pickupDetails?.SenderMobile, regex_name: 'exact_x_digits', required: true, errmsg: 'Please Enter Valid Number', x_count: 10 },
        // {tagid:'allPickupAddress', text: `${pickupAddress?.Address}, ${pickupAddress?.Cityid}, ${pickupAddress?.StateId}, ${pickupAddress?.Pincode}`??'', regex_name: 'free_text', required: true, errmsg: 'Please Enter Pickup Address.', min:1, max: 1000},
    ]

    // Submit Pick up data
    const onClickSubmitPickDetails = () => {
        const isAddressValid = checkValidation()
        if (rows.length === 0) {
            setError([{ tagid: 'NoOfPcs', errmsg: 'Please add at least one package detail.' }]);
            return;
        }
        // if (!checkValidation()) return; // early return if validation fails
        if (validate(validation_input)?.length == 0 && !isAddressValid) {
            // pickupDetails.Origin = Origin
            // pickupDetails.Destination =Destination
            if (pickupDate && pickupTime) {
                // Combine date + time into one datetime
                const combinedDateTime = dayjs(pickupDate).hour(pickupTime.hour()).minute(pickupTime.minute()).second(0).millisecond(0).toDate(); // JS Date object
                pickupDetails.PickupDateAndTime = combinedDateTime.toString();
            }
            pickupDetails.PickupAddress = `${pickupAddress?.Address}, ${pickupAddress?.Pincode}`
            pickupDetails.DestinationAddress = `${destinationAddress?.Address}, ${destinationAddress?.Pincode}`
            const normalizedRows = normalizePackageRows(rows, editPickupDetails?.NoOfPcs)
            const totalPcs = normalizedRows.reduce((sum, row) => sum + parseInt(row.NoOfPcs || 0, 10), 0)
            const legacyHeaderPcs = parseInt(editPickupDetails?.NoOfPcs || 0, 10)
            pickupDetails.PackageDetails = normalizedRows
            pickupDetails.NoOfPcs = totalPcs || legacyHeaderPcs || 0
            pickupDetails.SenderEmail = SenderEmail
            pickupDetails.ReceiverEmail = ReceiverEmail
            setLoader(true)
            if (Object.keys(editPickupDetails)?.length == 0) {
                dispatch(createPickupDetails(pickupDetails)).then((res) => {
                    if (res.payload.success === false) {
                        sweetalert('error', res?.payload?.message)
                    } else {
                        sweetalert('success', res?.payload?.message)
                        navigate('/dashboard/pickuplist')
                    }
                    setLoader(false)
                })
            } else {
                pickupDetails.RequestedId = editPickupDetails?.RequestedId
                dispatch(updatePickupDetails(pickupDetails)).then((res) => {
                    if (res.payload.success === false) {
                        sweetalert('error', res?.payload?.message)
                    } else {
                        sweetalert('success', res?.payload?.message)
                        navigate('/dashboard/pickuplist')
                    }
                    setLoader(false)
                })
            }
        } else {
            setError(validate(validation_input))
        }
    }

    const sweetalert = (variant, text) => {
        Swal.fire({
            icon: variant === 'error' ? 'error' : 'success',
            title: text,
            button: "Ok!",
        });
    }

    const addEmail = () => {
        const newEmail = inputValue.trim();
        if (newEmail && validateEmail(newEmail) && !ReceiverEmail.includes(newEmail)) {
            setReceiverEmail([...ReceiverEmail, newEmail]);
        }
        setInputValue('');
    };

    const addEmailSender = () => {
        const newEmail1 = inputValueSender.trim();
        if (newEmail1 && validateEmail(newEmail1) && !SenderEmail.includes(newEmail1)) {
            setSenderEmail([...SenderEmail, newEmail1]);
        }
        setInputValueSender('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addEmail();
        }
    };

    const handleBlur = () => {
        addEmail(); // Add email when focus is lost
    };

    const handleKeyDownSender = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addEmailSender();
        }
    };

    const handleBlurSender = () => {
        addEmailSender(); // Add email when focus is lost
    };

    const handleDelete = (emailToDelete) => {
        setReceiverEmail(ReceiverEmail.filter(email => email !== emailToDelete));
    };

    const handleDeleteSenderEmail = (emailToDelete) => {
        setSenderEmail(SenderEmail.filter(email => email !== emailToDelete));
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <HeaderName headerName={Object.keys(editPickupDetails).length > 0 ? 'Edit Pickup' : 'Add Pickup'} newForm={false} onClickBackButton={() => navigate("/dashboard/pickuplist")} />
                <Box className="custom-data-grid-container_table" style={{ backgroundColor: '#FFFFFF', margin: '5px 30px 5px 10px', border: '1px solid #FFFFF', borderRadius: '30px', width: '97%' }}>
                    <Grid container spacing={2} style={{ display: 'flex', padding: '20px 20px', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
                        {/* Render input fields for 'Pickup' */}
                        <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Office Name<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <AutoSearchDropdown
                                id="OfficeId"
                                name="OfficeId"
                                placeholder="Enter Office Name"
                                onChange={handleChangePickup}
                                value={
                                    officeList?.data?.find((o) => o.OfficeId === pickupDetails?.OfficeId)
                                        ? {
                                            label: officeList?.data?.find((o) => o.OfficeId === pickupDetails?.OfficeId)?.OfficeName,
                                            value: pickupDetails?.OfficeId
                                        }
                                        : null
                                }
                                options={officeList?.data?.map((name) => ({ value: name?.OfficeId, label: name?.OfficeName }))}
                                sx={{ borderRadius: '10px', mt: 0.5, background: '#ffffff' }}
                            />
                            <DisplayError error={error} fortagid='OfficeId' />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Customer Name<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <AutoSearchDropdown
                                id="Customer"
                                placeholder='Enter Customer Name'
                                name='Customer'
                                onChange={(e) => {
                                    const Customer = e?.target?.value;
                                    setPickupDetails((prev) => ({ ...prev, Customer: Customer }));
                                }}

                                value={
                                    CustomerList?.data?.find((o) => o.CustomerId === pickupDetails?.Customer)
                                        ? {
                                            label: CustomerList?.data?.find((o) => o.CustomerId === pickupDetails?.Customer)?.CustomerName,
                                            value: pickupDetails?.Customer
                                        }
                                        : null
                                }
                                options={CustomerList?.data?.map((name) => ({ value: name?.CustomerId, label: name?.CustomerName }))}
                                sx={{ borderRadius: '10px', mt: 0.5, background: '#ffffff' }}
                            />
                            <DisplayError error={error} fortagid='Customer' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Origin State<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <SelectDropDown id='State'
                                name='OriginState'
                                placeholder='Select'
                                value={pickupDetails?.OriginState}
                                onChange={handleChangePickup}
                                options={State?.getStatesOfCountry('IN').map((state) => { return { value: state?.isoCode, label: !state?.name ? '--Select City--' : state?.name } })}
                                sx={{ p: 0.1, mt: 0.5, pl: 1, height: '50px', backgroundColor: '#ffffff', borderRadius: '10px' }}
                            />
                            <DisplayError error={error} fortagid='OriginState' />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Origin City<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <SelectDropDown id='City'
                                name='Origin'
                                placeholder='Select'
                                value={pickupDetails?.Origin}
                                onChange={handleChangePickup}
                                options={City?.getCitiesOfState("IN", pickupDetails?.OriginState).map((city) => { return { value: city?.name, label: city?.name } })}
                                isDisabled={!pickupDetails?.OriginState}
                                sx={{ p: 0.1, mt: 0.5, pl: 1, height: '50px', backgroundColor: '#ffffff', borderRadius: '10px' }}
                            />
                            <DisplayError error={error} fortagid='Origin' />
                        </Grid>
                        {/* <Grid size={{ xs: 12, sm: 4, md: 4, lg:4 }}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Origin City<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                <SelectDropDown id='Origin'
                                    name="Origin"
                                    placeholder="Select City"
                                    options={cityOptions}
                                    value={Origin}
                                    onChange={(e) => setOrigin(e.target.value)}
                                    sx={{ height: '50px', mt: 0.5, borderRadius: '10px' }}
                                />
                                <DisplayError error={error} fortagid='Origin'/>
                            </Grid> */}
                        <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Destination State<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <SelectDropDown id='State'
                                name='DestinationState'
                                placeholder='Select'
                                value={pickupDetails?.DestinationState}
                                onChange={handleChangePickup}
                                options={State?.getStatesOfCountry('IN').map((state) => { return { value: state?.isoCode, label: !state?.name ? '--Select City--' : state?.name } })}
                                sx={{ p: 0.1, mt: 0.5, pl: 1, height: '50px', backgroundColor: '#ffffff', borderRadius: '10px' }}
                            />
                            <DisplayError error={error} fortagid='DestinationState' />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Destination City<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <SelectDropDown id='City'
                                name='Destination'
                                placeholder='Select'
                                value={pickupDetails?.Destination}
                                onChange={handleChangePickup}
                                options={City?.getCitiesOfState("IN", pickupDetails?.DestinationState).map((city) => { return { value: city?.name, label: city?.name } })}
                                isDisabled={!pickupDetails?.DestinationState}
                                sx={{ p: 0.1, mt: 0.5, pl: 1, height: '50px', backgroundColor: '#ffffff', borderRadius: '10px' }}
                            />
                            <DisplayError error={error} fortagid='Destination' />
                        </Grid>
                        {/* <Grid size={{ xs: 12, sm: 3, md: 3, lg:3 }}>
                               <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Destination City<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                <SelectDropDown id='Destination'
                                    name="Destination"
                                    placeholder="Select City"
                                    options={cityOptions}
                                    value={Destination || ""} 
                                    onChange={(e) => setDestination(e.target.value)}
                                    sx={{ height: '50px', mt: 0.5, borderRadius: '10px' }}
                                />
                                <DisplayError error={error} fortagid='Destination'/>
                            </Grid> */}

                        <Grid item xs={12} sm={3} md={3} lg={3}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                                Consignor (Sender)<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span>
                            </H4FormLabel>
                            <InputBox
                                id="Consignee"
                                name="Consignee"
                                placeholder="Enter Consignor Name"
                                value={pickupDetails?.Consignee || ''}
                                onChange={handleChangePickup}
                                sx={{
                                    border: "1px solid #b2b2b2",
                                    borderRadius: "10px",
                                    mt: 0.5,
                                    background: "#ffffff",
                                    width: "100%",           // Make it responsive
                                    minWidth: "290px",

                                    paddingLeft: '14px',     // Optional: minimum width
                                }}
                            />
                            <DisplayError error={error} fortagid="Consignee" />
                        </Grid>

                        <Grid item xs={12} sm={3} md={3} lg={3}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                                Consignee (Receiver)<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span>
                            </H4FormLabel>
                            <InputBox
                                id="Consigner"
                                name="Consigner"
                                placeholder="Enter Consignee Name"
                                value={pickupDetails?.Consigner || ''}
                                onChange={handleChangePickup}
                                sx={{
                                    border: "1px solid #b2b2b2",
                                    borderRadius: "10px",
                                    mt: 0.5,
                                    background: "#ffffff",
                                    width: "100%",           // Make it responsive
                                    minWidth: "280px",

                                    paddingLeft: '14px',      // Optional: minimum width
                                }}
                            />
                            <DisplayError error={error} fortagid="Consigner" />
                        </Grid>


                        <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor, mb: 0.5 }}>Sender Email<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            {/* <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Enter Email'
                                    name='SenderEmail'
                                    value={pickupDetails?.SenderEmail}
                                    onChange={handleChangePickup}
                                />
                                <DisplayError error={error} fortagid='SenderEmail'/> */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', border: "1px solid rgba(0, 0, 0, 0.3)", borderRadius: '10px', padding: '5px', backgroundColor: '#fff', minHeight: '40px' }}>
                                {SenderEmail.map((email, index) => (
                                    <Chip
                                        key={index}
                                        label={email}
                                        onDelete={() => handleDeleteSenderEmail(email)}
                                        color="primary"
                                    />
                                ))}
                                <TextField
                                    variant="standard"
                                    placeholder="Enter Email"
                                    value={inputValueSender}
                                    onChange={(e) => setInputValueSender(e.target.value)}
                                    onKeyDown={handleKeyDownSender}
                                    onBlur={handleBlurSender}
                                    InputProps={{ disableUnderline: true }}
                                    sx={{ flex: 1, minWidth: 150 }}
                                />
                            </Box>
                            <DisplayError error={error} fortagid='SenderEmail' />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor, mb: 0.5 }}>Receiver Email<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            {/*                                  <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Enter Email'
                                    name='ReceiverEmail'
                                    value={pickupDetails?.ReceiverEmail}
                                    onChange={handleChangePickup}
                                />
                                <DisplayError error={error} fortagid='ReceiverEmail'/>
                            </Grid> */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', border: "1px solid rgba(0, 0, 0, 0.3)", borderRadius: '10px', padding: '5px', backgroundColor: '#fff', minHeight: '40px' }}>
                                {ReceiverEmail.map((email, index) => (
                                    <Chip
                                        key={index}
                                        label={email}
                                        onDelete={() => handleDelete(email)}
                                        color="primary"
                                    />
                                ))}
                                <TextField
                                    variant="standard"
                                    placeholder="Enter Email"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    onBlur={handleBlur}
                                    InputProps={{ disableUnderline: true }}
                                    sx={{ flex: 1, minWidth: 150 }}
                                />
                            </Box>
                            <DisplayError error={error} fortagid='ReceiverEmail' />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Gross Weight (kg)<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                placeholder='Enter Gross Weight'
                                name='GrossWeight'
                                value={pickupDetails?.GrossWeight}
                                onChange={handleChangePickup}
                            />
                            <DisplayError error={error} fortagid='GrossWeight' />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Datalogger<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <SelectDropDown
                                id='DataLoggerValue'
                                name='DataLoggerValue'
                                placeholder='Select'
                                options={[{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }]}
                                // disabled={fieldDisabled }  
                                onChange={handleChangePickup}
                                value={pickupDetails?.DataLoggerValue}
                                sx={{ backgroundColor: "#FFFFFF", p: 0.1, mt: 0.5, pl: 1, height: '50px', borderRadius: "10px" }}
                            />
                            <DisplayError error={error} fortagid='DataLoggerValue' />
                        </Grid>

                        {pickupDetails?.DataLoggerValue === 'Yes' ? <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Datalogger Value<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                placeholder='Enter Datalogger'
                                name='DataLogger'
                                value={pickupDetails?.DataLogger}
                                onChange={handleChangePickup}
                            />
                            <DisplayError error={error} fortagid='DataLogger' />
                        </Grid> : <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}></Grid>}

                        <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Length (cm)
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <TextField name="length" label="length" fullWidth value={form?.length} onChange={handleInputChange} sx={{
                                '& .MuiInputBase-root': { marginTop: '3px', height: '50px', fontSize: '14px', borderRadius: '10px', },
                                '& .MuiInputLabel-root': { fontSize: '14px' },
                                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.3)' }
                            }}
                            />
                            <DisplayError error={error} fortagid='length' />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ display: 'flex', padding: '0px 20px', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
                        <Grid size={{ xs: 12, sm: 1, md: 1, lg: 1.2 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>No. of Pcs<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                placeholder='Enter No Of Pcs'
                                name='NoOfPcs'
                                value={form?.NoOfPcs}
                                onChange={handleInputChange}
                                onKeyPress={(e) => {
                                    const keyCode = e.keyCode || e.which;
                                    const keyValue = String.fromCharCode(keyCode);
                                    const numericRegex = /^[0-9]*$/;
                                    if (!numericRegex.test(keyValue)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            <DisplayError error={error} fortagid='NoOfPcs' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 1, md: 1, lg: 1.2 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Breadth (cm)
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <TextField name="breadth" label="breadth" fullWidth value={form?.breadth} onChange={handleInputChange} sx={{
                                '& .MuiInputBase-root': { marginTop: '3px', height: '50px', fontSize: '14px', borderRadius: '10px', },
                                '& .MuiInputLabel-root': { fontSize: '14px' },
                                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.3)' }
                            }} />
                            <DisplayError error={error} fortagid='breadth' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 1, md: 1, lg: 1.2 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Height (cm)
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <TextField name="height" label="height" fullWidth value={form?.height} onChange={handleInputChange} sx={{
                                '& .MuiInputBase-root': { marginTop: '3px', height: '50px', fontSize: '14px', borderRadius: '10px', },
                                '& .MuiInputLabel-root': { fontSize: '14px' },
                                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.3)' }
                            }} />
                            <DisplayError error={error} fortagid='height' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 1, md: 1, lg: 1 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Volume
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <TextField name="Volumetrix" label="Volume" fullWidth value={form?.Volumetrix} onChange={handleInputChange} sx={{
                                '& .MuiInputBase-root': { marginTop: '5px', height: '50px', fontSize: '14px', borderRadius: '10px', },
                                '& .MuiInputLabel-root': { fontSize: '14px' },
                                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.3)' }
                            }} />
                            <DisplayError error={error} fortagid='Volumetrix' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2, md: 2, lg: 1.5 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Box Type
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                placeholder='Type'
                                name='BoxType'
                                value={form?.BoxType}
                                onChange={handleInputChange}
                            />
                            <DisplayError error={error} fortagid='BoxType' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2, md: 2, lg: 1.5 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Actual weight
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                placeholder='Type'
                                name='Actualweight'
                                value={form?.Actualweight}
                                onChange={handleInputChange}
                            />
                            <DisplayError error={error} fortagid='Actualweight' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2, md: 2, lg: 1.5 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Temperature Type
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <SelectDropDown
                                id='TemperatureTypeId'
                                name='TemperatureTypeId'
                                placeholder='Select'
                                options={[{ value: 'AMB', label: 'AMB' }, { value: 'REF', label: 'REF' }, { value: 'FRZ', label: 'FRZ' }, { value: 'Other', label: 'Other' }]}
                                onChange={handleInputChange}
                                value={form?.TemperatureTypeId}
                                sx={{ backgroundColor: "#FFFFFF", p: 0.1, mt: 0.5, pl: 1, height: '50px', borderRadius: "10px" }}
                            />
                            <DisplayError error={error} fortagid='TemperatureTypeId' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2, md: 2, lg: 1.5 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Temperature (°C)
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                placeholder='Enter Temperature'
                                name='Temperature'
                                value={form?.Temperature?.trim()}
                                onChange={handleInputChange}
                            />
                            <DisplayError error={error} fortagid='Temperature' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2, md: 2, lg: 1.5 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Pkg/Pack
                                {/* <span style={{color:'#FF0000', fontWeight:700}}>*</span> */}
                            </H4FormLabel>
                            <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                placeholder='Enter Pkg'
                                name='Pkg'
                                value={form?.Pkg}
                                onChange={handleInputChange}
                            />
                            <DisplayError error={error} fortagid='Pkg' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 1, md: 1, lg: 1 }} sx={{ mt: 3 }}>
                            <IconButton onClick={handleAddRow} color="primary" sx={{ backgroundColor: '#e0f7fa', '&:hover': { backgroundColor: '#b2ebf2', }, }}>
                                <AddIcon />
                            </IconButton>
                        </Grid>

                        {/* Table Display */}
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ mb: 1 }}>
                            <Box sx={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #ccc', borderRadius: 1 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold' }}>No.</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Length</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Height</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Breadth</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Volume</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Actual Weight</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Box Type</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Temperature Type</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Temperature</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Pkg/Pack</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows?.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={7} align="center">
                                                    No Data Found
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            rows?.map((row, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{getRowNoOfPcs(row)}</TableCell>
                                                    <TableCell>{row.length} {'cm'}</TableCell>
                                                    <TableCell>{row.height} {'cm'}</TableCell>
                                                    <TableCell>{row.breadth} {'cm'}</TableCell>
                                                    <TableCell>{row.Volumetrix}</TableCell>
                                                    <TableCell>{row.Actualweight}</TableCell>
                                                    <TableCell>{row.BoxType}</TableCell>
                                                    <TableCell>{row.TemperatureTypeId}</TableCell>
                                                    <TableCell>{row.Temperature} {'°C'}</TableCell>
                                                    <TableCell>{row.Pkg}</TableCell>
                                                    <TableCell>
                                                        <IconButton id='edit' onClick={() => handleClickEditRow(idx, row)}><EditIcon w={18} h={18} /></IconButton>
                                                        <IconButton id='delete' onClick={() => handleDeleteRow(idx, row)}><DeleteIcon fontSize="medium" style={{ color: '#04AB44' }} /></IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                                Pickup Date <span style={{ color: '#FF0000', fontWeight: 700 }}>*</span>
                            </H4FormLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Select Date"
                                    value={pickupDate}
                                    onChange={(newDate) => setPickupDate(newDate)}
                                    sx={{ width: '100%', backgroundColor: "#FFFFFF" }}
                                    slotProps={{ popper: { placement: 'left' } }}
                                />
                            </LocalizationProvider>
                             <DisplayError error={error} fortagid='PickupDate' />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                                Pickup Time <span style={{ color: '#FF0000', fontWeight: 700 }}>*</span>
                            </H4FormLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    label="Select Time"
                                    value={pickupTime}
                                    onChange={(newTime) => setPickupTime(newTime)}
                                    sx={{ width: '100%', backgroundColor: "#FFFFFF" }}
                                    slotProps={{ popper: { placement: 'left' } }}
                                />
                            </LocalizationProvider>
                             <DisplayError error={error} fortagid='PickupTime' />
                        </Grid>


                        <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor, mt: 0.5 }}>Contents<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <SelectDropDown id='Content'
                                name='Content'
                                placeholder='Select'
                                value={pickupDetails?.Content}
                                onChange={handleChangePickup}
                                options={ContentsList}
                                sx={{ p: 0.1, mt: 0.5, pl: 1, height: '50px', backgroundColor: '#ffffff', borderRadius: '10px' }}
                            />
                            <DisplayError error={error} fortagid='Content' />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                            <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor, mt: 0.5 }}>Package Type<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                placeholder='Enter Type'
                                name='PackegeType'
                                value={pickupDetails?.PackegeType}
                                onChange={handleChangePickup}
                            />
                            <DisplayError error={error} fortagid='PackegeType' />
                        </Grid>
                        {/* 
                            <Grid size={{ xs: 12, sm: 4, md: 4, lg:4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Pickup Registered Mobile No<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Enter Number'
                                    name='PickupRegisteredNumber'
                                    value={pickupDetails?.PickupRegisteredNumber}
                                    onChange={(e)=>{
                                        if(e.target.value.length <=10)handleChangePickup(e)
                                    }} 
                                    onKeyPress={(e) => {
                                        const keyCode = e.keyCode || e.which;
                                        const keyValue = String.fromCharCode(keyCode);
                                        const numericRegex = /^[0-9]*$/;
                                        if (!numericRegex.test(keyValue)) {
                                        e.preventDefault();
                                        }
                                    }} 
                                />
                                <DisplayError error={error} fortagid='PickupRegisteredNumber'/> 
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4, lg:4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Pickup Registered By<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Enter Name'
                                    name='PickupRegistered'
                                    value={pickupDetails?.PickupRegistered}
                                    onChange={handleChangePickup}
                                />
                                <DisplayError error={error} fortagid='PickupRegistered'/> 
                            </Grid> */}


                        <Grid container spacing={2} sx={{ m: 2 }}>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Pickup Address<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Destination Address<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <InputBox sx={{ height: '30px', borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Flat/Building/Street/Locality'
                                    name='Address'
                                    value={pickupAddress?.Address}
                                    onChange={(e) => setPickupAdress({ ...pickupAddress, Address: e.target.value })}
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <InputBox sx={{ height: '30px', borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Flat/Building/Street/Locality'
                                    name='Address'
                                    value={destinationAddress?.Address}
                                    onChange={(e) => setDestinationAdress({ ...destinationAddress, Address: e.target.value })}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <InputBox sx={{ height: '30px', borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Pincode'
                                    name='Pincode'
                                    onChange={(e) => {
                                        if (e.target.value.length <= 6) {
                                            setPickupAdress({ ...pickupAddress, Pincode: e.target.value })
                                        }
                                    }}
                                    onKeyPress={(e) => {
                                        const keyCode = e.keyCode || e.which;
                                        const keyValue = String.fromCharCode(keyCode);
                                        const numericRegex = /^[0-9]*$/;
                                        if (!numericRegex.test(keyValue)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    value={pickupAddress?.Pincode}
                                />
                                {displayErrorMsg === true ? <Typography style={{ color: 'red', fontSize: '13px' }}>Please fill all required Pickup Address.</Typography> : ''}
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <InputBox sx={{ height: '30px', borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Pincode'
                                    name='Pincode'
                                    onChange={(e) => {
                                        if (e.target.value.length <= 6) {
                                            setDestinationAdress({ ...destinationAddress, Pincode: e.target.value })
                                        }
                                    }}
                                    onKeyPress={(e) => {
                                        const keyCode = e.keyCode || e.which;
                                        const keyValue = String.fromCharCode(keyCode);
                                        const numericRegex = /^[0-9]*$/;
                                        if (!numericRegex.test(keyValue)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    value={destinationAddress?.Pincode}
                                // onChange={(e) => setDestinationAdress({ ...destinationAddress, Pincode: e.target.value })}
                                />
                                {displayErrorMsg === true ? <Typography style={{ color: 'red', fontSize: '13px' }}>Please fill all required Destination Address fields.</Typography> : ''}
                            </Grid>


                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <InputBox sx={{ height: '30px', borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Sender Name'
                                    name='SenderName'
                                    value={pickupDetails?.SenderName}
                                    onChange={handleChangePickup}
                                />
                                <DisplayError error={error} fortagid='SenderName' />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <InputBox sx={{ height: '30px', borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Receiver Name'
                                    name='ReceiverName'
                                    value={pickupDetails?.ReceiverName}
                                    onChange={handleChangePickup}
                                />
                                <DisplayError error={error} fortagid='ReceiverName' />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <InputBox sx={{ height: '30px', borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Sender Mobile'
                                    name='SenderMobile'
                                    value={pickupDetails?.SenderMobile}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10) handleChangePickup(e)
                                    }}
                                    onKeyPress={(e) => {
                                        const keyCode = e.keyCode || e.which;
                                        const keyValue = String.fromCharCode(keyCode);
                                        const numericRegex = /^[0-9]*$/;
                                        if (!numericRegex.test(keyValue)) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                <DisplayError error={error} fortagid='SenderMobile' />
                            </Grid>


                            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <InputBox sx={{ height: '30px', borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Receiver Mobile'
                                    name='ReceiverMobile'
                                    value={pickupDetails?.ReceiverMobile}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10) handleChangePickup(e)
                                    }}
                                    onKeyPress={(e) => {
                                        const keyCode = e.keyCode || e.which;
                                        const keyValue = String.fromCharCode(keyCode);
                                        const numericRegex = /^[0-9]*$/;
                                        if (!numericRegex.test(keyValue)) {
                                            e.preventDefault();
                                        }
                                    }}
                                />
                                <DisplayError error={error} fortagid='ReceiverMobile' />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                <H4FormLabel sx={{ mb: 0.5, color: ThemeColor.palette.InputTextColor }}>Remark<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                <TextArea id='Remark' name='Remark' value={pickupDetails?.Remark} onChange={handleChangePickup} style={{ height: '40px', border: "1px solid rgba(0, 0, 0, 0.3)" }} placeholder="Enter Remark"></TextArea>
                                <DisplayError error={error} fortagid='Remark' />
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 10, md: 10, lg: 12 }} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                id="save"
                                variant="contained"
                                // disabled={loader}
                                onClick={onClickSubmitPickDetails}
                                sx={{
                                    color: '#FFFFFF', backgroundColor: '#04AB44',
                                    '&:hover': { backgroundColor: '#04AB44', color: '#FFFFFF' },
                                    fontSize: '16px', fontWeight: '500', borderRadius: "10px", pl: 5, pr: 5, textTransform: 'none', boxShadow: '0px 4px 6px #e1e1e1', mb: 4, letterSpacing: '1px'
                                }}>
                                {loader ? <CircularProgress size={20} color="inherit" /> : 'Save'}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </div>
        </>
    )
}

export default NewPickup;
